import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { CLIENT_V2, PATCH_INVOICING_CONFIG } from "../../../../../utils/data/models";
import { RectangleSpinner } from "../../../../common/spinners";
import { FormattedMessage } from "react-intl";
import InvoicingConfigurationForm from "./InvoicingConfigurationForm";
import { toast } from "react-toastify";
import _ from "lodash";
import * as types from "../../../../../utils/data/dataActionTypes";
import { isSimpleFetchToast } from "../../../../common/RouteValidators/ClientValidationHelper";

class InvoicingConfiguration extends React.Component {
    /**
        * Component that will pass down the form logic to the form.
        */

    constructor(props, context) {
        super(props, context);
        this.state = {
            initialValues: {},
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmit = _.debounce(this.handleSubmit.bind(this), 350); // Debounce func to avoid button spamming

        this.state = {
            submitting: false,
        };
    }
    componentDidMount() {
        this.props.activeClient && this.props.dataActions.getDataItem(CLIENT_V2, this.props.activeClient.clientId).then((res) => {
            const simpleFetchToast = isSimpleFetchToast(res);
            if (res && res.type != types.GET_DATA_ITEM_SUCCESS && !simpleFetchToast) {
                toast(<FormattedMessage id="clients.client.errors.fetchingError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: true,
                });
            }
            else {
                this.setState({
                    initialValues: {
                        creditsInvoiceFrequency: res.payload.data.creditsInvoiceFrequency,
                        creditsInvoiceCount: res.payload.data.creditsInvoiceCount,
                    }
                });
            }
        });
    }

    handleSubmit(formValues) {
        this.setState({ submitting: true });
        const { activeClient, dataActions } = this.props;
        const model = { path: PATCH_INVOICING_CONFIG.path.replace("{}", activeClient.clientId) };
        try {
            dataActions.updateDataItem(model, formValues).then((data) => {
                if (data.type == types.UPDATE_DATA_ITEM_FAILURE) {
                    toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                    this.setState({ submitting: false });
                }
                else {
                    dataActions.getDataItem(CLIENT_V2, activeClient.clientId);
                    toast(<FormattedMessage id="invoicingConfig.successToast" />, {
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                    });
                }
            });
            this.setState({ submitting: false });
        } catch (e) {
            toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
            this.setState({ submitting: false });
        }
    }

    render() {
        const { activeClient } = this.props;
        return activeClient && this.state.initialValues ? (
            <InvoicingConfigurationForm
                submitting={this.state.submitting}
                initialValues={this.state.initialValues}
                client={activeClient}
                onSubmit={this.handleSubmit}
            />
        ) : (
            <RectangleSpinner />
        );
    }
}

InvoicingConfiguration.propTypes = {
    activeClient: PropTypes.object,
    dataActions: PropTypes.object
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        activeClient: state.data.clients ? state.data.clients.active : null,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoicingConfiguration);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoicing-configuration/InvoicingConfiguration.js